


























import { Vue, Prop, Emit, Component } from 'vue-property-decorator'

@Component
export default class SearchRelevanceChooser extends Vue {
  @Prop({ type: String, required: true }) readonly sortorder!: string

  @Emit('set-sortorder')
  setSortorder(sortorder: string) {
    return sortorder
  }
}
